// 初始化数据
const modal = {
  searchResult: [], //查询结果数据
  searchParams: {}, // 搜索传值
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  isShowSearch: false,
  bansList: [],
  indexRecord: null,
  modalInfoMsg: '',
  indexStatus: 0,
  isShowModal: false,
  confirmLoading: false,
  btnLoading: false, //防止表格中的按钮连续点击
  modalTuttonLoading: false,
  steps: [],
  stepShow: false,
  fileList: [], //上传附件列表
  fileName: '',
  editFileList: [], //查看附件列表
  toolState: 'add',
  UploadModalStatus: false, //上传附件组件显示状态
  iconLoading: false,
  RedFlushVisible: false,
  newData: {},
  aggregateAmount: '暂无',
  redRushAuthority: false,
  deleteAuthority: false,
};
export default modal;
